export const ActionPlayer = {
  PLAYER_LIST: 'PLAYER_LIST',
  PLAYER_BUZZ: 'PLAYER_BUZZ',

  SEND_TEXT_RESPONSE: 'SEND_TEXT_RESPONSE',
  SEND_DRAWING: 'SEND_DRAWING',
};
